import React from 'react'
import './SignUp.css'
import { Typography } from '@material-ui/core'
import { useSelector, useDispatch } from 'react-redux'
import { setFullName, setPosition } from 'redux/actions/'

export default function Login() {
  const dispatch = useDispatch()
  const { fullName, position } = useSelector(state => state.signup)
  return (
    <>
      <Typography variant="h2" align="center" style={{ padding: '25px 0' }}>
        What is your name and position?
      </Typography>
      <div>
        <label>Full Name</label>
        <input
          placeholder="John Doe"
          type="text"
          value={fullName}
          onChange={e => dispatch(setFullName(e.target.value))}
        />
        <label htmlFor="standard-select">Position in Agency</label>
        <input
          placeholder="Co-Founder"
          type="text"
          value={position}
          onChange={e => dispatch(setPosition(e.target.value))}
        />
      </div>
    </>
  )
}
